// Date parsing/derivation helpers, ported from the Apps Script importers.
// Normalisers return native Date objects; the Firestore SDK converts Date ->
// Timestamp on write.

const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

/** Add `n` business days (skipping Sat/Sun) to a Date. Returns a new Date. */
export function addBusinessDays(date, n) {
  const d = new Date(date.getTime());
  let added = 0;
  while (added < n) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay();
    if (day !== 0 && day !== 6) added += 1;
  }
  return d;
}

/** Our derived dispatch target: order date + 3 business days (calculatePostByDate). */
export function calculatePostByDate(orderDate) {
  if (!orderDate || Number.isNaN(orderDate.getTime?.())) return null;
  return addBusinessDays(orderDate, 3);
}

/** Etsy "Sale Date" "MM/DD/YY" (or "MM/DD/YYYY") -> Date (convertToISODate). */
export function parseEtsyDate(value) {
  if (!value) return null;
  const parts = String(value).trim().split('/');
  if (parts.length !== 3) return null;
  let [month, day, year] = parts;
  if (year.length === 2) year = `20${year}`;
  const d = new Date(Number(year), Number(month) - 1, Number(day));
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Shopify "Created at" e.g. "2026-06-04 09:17:18 +0100" -> Date. */
export function parseShopifyDate(value) {
  if (!value) return null;
  // Native parser handles the "YYYY-MM-DD HH:MM:SS +ZZZZ" form.
  const d = new Date(String(value).trim());
  return Number.isNaN(d.getTime()) ? null : d;
}

/** eBay date e.g. "03-Jun-26" / "03-Jun-2026" (dd-MMM-yy) -> Date. */
export function parseEbayDate(value) {
  if (!value) return null;
  const m = String(value).trim().match(/^(\d{1,2})-([A-Za-z]{3})-(\d{2,4})$/);
  if (!m) {
    const d = new Date(String(value).trim());
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const day = Number(m[1]);
  const monthIdx = MONTHS.indexOf(m[2].toLowerCase());
  let year = Number(m[3]);
  if (year < 100) year += 2000;
  if (monthIdx === -1) return null;
  const d = new Date(year, monthIdx, day);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Earliest of two nullable Dates (for postByEffective). */
export function earliestDate(a, b) {
  if (a && b) return a.getTime() <= b.getTime() ? a : b;
  return a || b || null;
}
